// extracted by mini-css-extract-plugin
export default {"link":"XrUsU9TtVFQgrC2J2F1Y","label":"qe0MXz14Lld3rFyt9fGA"};